export default {
  TW: '台灣',
  US: '美國',
  AG: '安地卡及巴布達',
  AI: '安圭拉',
  AS: '美屬薩摩亞',
  BB: '巴貝多',
  BM: '百慕達',
  BS: '巴哈馬',
  CA: '加拿大',
  DM: '多明尼加',
  DO: '多明尼加共和國',
  GD: '格瑞那達',
  GU: '關島',
  JM: '牙買加',
  KN: '聖克里斯多福及尼維斯',
  KY: '開曼群島',
  LC: '聖露西亞',
  MP: '北馬里亞納群島',
  MS: '蒙特色拉特島',
  PR: '波多黎各',
  SX: '荷屬聖馬丁',
  TC: '土克凱可群島',
  TT: '千里達及托巴哥',
  VC: '聖文森及格瑞那丁',
  VG: '英屬維京群島',
  VI: '美屬維京群島',
  RU: '俄羅斯',
  KZ: '哈薩克',
  EG: '埃及',
  ZA: '南非',
  GR: '希臘',
  NL: '荷蘭',
  BE: '比利時',
  FR: '法國',
  ES: '西班牙',
  HU: '匈牙利',
  IT: '義大利',
  VA: '梵蒂岡',
  RO: '羅馬尼亞',
  CH: '瑞士',
  AT: '奧地利',
  GB: '英國',
  GG: '根息',
  IM: '曼島',
  JE: '澤西島',
  DK: '丹麥',
  SE: '瑞典',
  NO: '挪威',
  SJ: '斯瓦巴及揚馬延群島',
  PL: '波蘭',
  DE: '德國',
  PE: '祕魯',
  MX: '墨西哥',
  CU: '古巴',
  AR: '阿根廷',
  BR: '巴西',
  CL: '智利',
  CO: '哥倫比亞',
  VE: '委內瑞拉',
  MY: '馬來西亞',
  AU: '澳洲',
  CC: '可可斯群島',
  CX: '聖誕島',
  ID: '印尼',
  PH: '菲律賓',
  NZ: '紐西蘭',
  SG: '新加坡',
  TH: '泰國',
  JP: '日本',
  KR: '韓國',
  VN: '越南',
  CN: '中國',
  TR: '土耳其',
  IN: '印度',
  PK: '巴基斯坦',
  AF: '阿富汗',
  LK: '斯里蘭卡',
  MM: '緬甸',
  IR: '伊朗',
  SS: '南蘇丹',
  MA: '摩洛哥',
  EH: '西撒哈拉',
  DZ: '阿爾及利亞',
  TN: '突尼西亞',
  LY: '利比亞',
  GM: '甘比亞',
  SN: '塞內加爾',
  MR: '茅利塔尼亞',
  ML: '馬利',
  GN: '幾內亞',
  CI: '象牙海岸',
  BF: '布吉納法索',
  NE: '尼日',
  TG: '多哥',
  BJ: '貝南',
  MU: '模里西斯',
  LR: '賴比瑞亞',
  SL: '獅子山',
  GH: '迦納',
  NG: '奈及利亞',
  TD: '查德',
  CF: '中非共和國',
  CM: '喀麥隆',
  CV: '維德角',
  ST: '聖多美及普林西比',
  GQ: '赤道幾內亞',
  GA: '加彭',
  CG: '剛果共和國',
  CD: '剛果民主共和國',
  AO: '安哥拉',
  GW: '幾內亞比索',
  IO: '英屬印度洋領地',
  AC: '亞森松島',
  SC: '塞席爾',
  SD: '蘇丹',
  RW: '盧安達',
  ET: '衣索比亞',
  SO: '索馬利亞',
  DJ: '吉布地',
  KE: '肯亞',
  TZ: '坦尚尼亞',
  UG: '烏干達',
  BI: '蒲隆地',
  MZ: '莫三比克',
  ZM: '尚比亞',
  MG: '馬達加斯加',
  RE: '留尼旺',
  YT: '馬約特',
  ZW: '辛巴威',
  NA: '納米比亞',
  MW: '馬拉威',
  LS: '賴索托',
  BW: '波札那',
  SZ: '史瓦帝尼',
  KM: '葛摩',
  SH: '聖赫倫那',
  TA: '特里斯坦達庫尼亞群島',
  ER: '厄立特里亞',
  AW: '阿魯巴',
  FO: '法羅群島',
  GL: '格陵蘭',
  GI: '直布羅陀',
  PT: '葡萄牙',
  LU: '盧森堡',
  IE: '愛爾蘭',
  IS: '冰島',
  AL: '阿爾巴尼亞',
  MT: '馬爾他',
  CY: '賽普勒斯',
  FI: '芬蘭',
  AX: '奧蘭群島',
  BG: '保加利亞',
  LT: '立陶宛',
  LV: '拉脫維亞',
  EE: '愛沙尼亞',
  MD: '摩爾多瓦',
  AM: '亞美尼亞',
  BY: '白俄羅斯',
  AD: '安道爾',
  MC: '摩納哥',
  SM: '聖馬利諾',
  UA: '烏克蘭',
  RS: '塞爾維亞',
  ME: '蒙特內哥羅',
  XK: '科索沃',
  HR: '克羅埃西亞',
  SI: '斯洛維尼亞',
  BA: '波士尼亞與赫塞哥維納',
  MK: '北馬其頓',
  CZ: '捷克',
  SK: '斯洛伐克',
  LI: '列支敦斯登',
  FK: '福克蘭群島',
  BZ: '貝里斯',
  GT: '瓜地馬拉',
  SV: '薩爾瓦多',
  HN: '宏都拉斯',
  NI: '尼加拉瓜',
  CR: '哥斯大黎加',
  PA: '巴拿馬',
  PM: '聖皮埃爾和密克隆群島',
  HT: '海地',
  GP: '瓜德羅普',
  BL: '聖巴瑟米',
  MF: '法屬聖馬丁',
  BO: '玻利維亞',
  GY: '蓋亞那',
  EC: '厄瓜多',
  GF: '法屬圭亞那',
  PY: '巴拉圭',
  MQ: '馬丁尼克',
  SR: '蘇利南',
  UY: '烏拉圭',
  CW: '庫拉索',
  BQ: '荷屬加勒比',
  TL: '東帝汶',
  NF: '諾福克島',
  BN: '汶萊',
  NR: '諾魯',
  PG: '巴布亞紐幾內亞',
  TO: '東加',
  SB: '索羅門群島',
  VU: '萬那杜',
  FJ: '斐濟',
  PW: '帛琉',
  WF: '瓦利斯和富圖那群島',
  CK: '庫克群島',
  NU: '紐埃',
  WS: '薩摩亞',
  KI: '吉里巴斯',
  NC: '新喀里多尼亞',
  TV: '吐瓦魯',
  PF: '法屬玻里尼西亞',
  TK: '托克勞',
  FM: '密克羅尼西亞',
  MH: '馬紹爾群島',
  KP: '北韓',
  HK: '香港',
  MO: '澳門',
  KH: '柬埔寨',
  LA: '寮國',
  BD: '孟加拉',
  MV: '馬爾地夫',
  LB: '黎巴嫩',
  JO: '約旦',
  SY: '敘利亞',
  IQ: '伊拉克',
  KW: '科威特',
  SA: '沙烏地阿拉伯',
  YE: '葉門',
  OM: '阿曼',
  PS: '巴勒斯坦',
  AE: '阿拉伯聯合大公國',
  IL: '以色列',
  BH: '巴林',
  QA: '卡達',
  BT: '不丹',
  MN: '蒙古',
  NP: '尼泊爾',
  TJ: '塔吉克',
  TM: '土庫曼',
  AZ: '亞塞拜然',
  GE: '喬治亞',
  KG: '吉爾吉斯',
  UZ: '烏茲別克',
} as Record<string, string>;
